import * as React from "react";
const SvgProgressMarker = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 21 19", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M13.9641 16.3368C12.4245 19.0035 8.5755 19.0035 7.0359 16.3368L1.40673 6.58679C-0.132868 3.92012 1.79164 0.586792 4.87084 0.586792L16.1292 0.586793C19.2084 0.586793 21.1329 3.92013 19.5933 6.58679L13.9641 16.3368Z", fill: "currentColor" }));
export default SvgProgressMarker;
